import OperatingModeLookupResourceModel from '../../generated/types/model/resource/OperatingModeLookupResourceModel';

export default class OperatingModeLookupResourceViewModel extends OperatingModeLookupResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
